import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const MontIIABCDE2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/Mont2ABCDE/7.webp`;
 

 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1.8,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1.8,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1.8,
    cols: 1,
}
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
       Community Helpers
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: Montessori II A,B,C,D & E Date: 17 March 2026

        </Typography>
        {/* <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
        <stronng>A journey through the wonders of India</stronng> 
<br/>

   “India is a land where every corner tells a story of culture, heritage and timeless beauty.”

<br/>
        </Typography> */}

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        On 17th March 2026, the Montessori II children conducted the morning assembly. The program began with a welcome speech, simple exercises and recitation of shlokas. Children then shared the Thought for the Day followed by a brief introduction to the assembly. 
        <br></br>
        Children also participated in a fun Fancy Dress activity where they dressed up as various professionals such as doctor, police officer, firefighter, pilot, etc. Using creative costumes and props like stethoscopes, toy gun, jet, ship, they confidently came on the stage and introduced the profession they represented. This activity helped them learn about different professions while enriching their vocabulary, communication skills, creativity and confidence.
        <br></br>
        The assembly concluded with a note of gratitude, followed by a lively ramp walk. Overall it was a joyful learning experience where children confidently expressed themselves and enjoyed exploring different professions.           
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Everyone can be great, because everyone can serve”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default MontIIABCDE2025;